(ns ycweb.app.admin.tasks.common
  (:require
   #?@(:clj
       [[clj-time.core :as dt]]
       :cljs
       [[cljs-time.core :as dt]])
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.forms :as forms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))


;; TODO: Surely this should be in a more common place somewhere by now.
(defn user-image [user {:keys [size status]}]
  (let [{:keys [ent/image ent/display-name] :as u} user
        hsh (if (:ent/uuid u) (mod (hash (:ent/uuid u)) 10) 5)]
    [:img.avatar
     {:class
      (u/bem :admin-user-image
        [(case status
           nil nil
           (:active :me) :is-active
           :removed :is-removed
           :is-inactive)]),
      :style
      {:min-width size
       :min-height size
       :width size
       :height size
       :box-shadow "0 0 0 0"}
      :align :left
      :src
      (u/cloudinary (:doc/public-id image)
        {:h size
         :w size
         :q "auto"
         :f "auto"
         :avatar? true
         :default-letter (str/lower (first display-name))})
      :title display-name}]))

(defn task-id [row]
  (str (str/upper (str/subs (get-in row [:task/team :ent/display-name]) 0 3))
    "-" (str/upper (str/subs (str (:ent/uuid row)) -4))))

(defn task-branch [row]
  (str
    (task-id row)
    "-"
    (->
      (:ent/display-name row)
      (str/subs 0 12)
      (str/trim)
      (str/replace #"[ ]+" "-")
      (str/replace #"[-]+" "-")

      (str/replace #"[^A-Za-z0-9-]" "")
      (str/upper))))

(defn person-cell [app-atom row col v]
  [:div
   {:style {:padding "8px 6px"}
    :class (u/bem :flex-grid-group [:align-left :valign-middle])}
   [:div
    {:style {:margin-right "4px"}
     :class (u/bem :flex-grid-block [:fluid :flush])}
    [:div.flex-grid-content
     [:span (user-image v {:size 22})]]]
   [:div
    {:class (u/bem :flex-grid-block [:fluid :flush])}
    [:div.flex-grid-content
     (or
       (:ent/display-name v)
       (:user/email v))]]])

(defn multi-person-cell [app-atom row col v]
  [:div
   {:style {:padding "8px 6px"}
    :class (u/bem :flex-grid-group [:align-left :valign-middle])}
   (map
     (fn [[_ person]]
       (list
         [:div
          {:style {:margin-right "4px"}
           :class (u/bem :flex-grid-block [:fluid :flush])}
          [:div.flex-grid-content
           [:span (user-image person {:size 22})]]]
         [:div
          {:class (u/bem :flex-grid-block [:fluid :flush])}
          [:div.flex-grid-content
           (or
             (:ent/display-name person)
             (:user/email person))]]))
     v)])

(defn person-cell-toggle [app-atom list-atom {:keys [item-selector selected-key]} v]
  [:div
   {:style {:padding "8px 4px"}
    :class (u/bem :flex-grid-group [:flush :align-left :valign-middle])}
   [:div
    {:class (u/bem :flex-grid-block [:fluid :flush])}
    [:div.flex-grid-content
     (forms/toggle "" (rum/cursor-in list-atom [(get v item-selector) selected-key])
       {:on-change identity})]]
   [:div
    {:class (u/bem :flex-grid-block [:fluid :flush])}
    [:div.flex-grid-content
     (person-cell app-atom {} {} v)]]])

(defn person-cell-selected [app-atom action-config row v]
  [:span
   {:class (u/bem :text-pill [:medium :light])
    :style
    {:margin-right "4px"
     :background-color (or (:ent/color v) "#eeeeee")}}
   (person-cell app-atom row {} v)])

(defn task-uid-cell [app-atom row col v]
  [:div {:style {:white-space "nowrap"}}
   (buttons/button-web
     (task-id row)
     (merge
       (urlstate/href-props app-atom "tasks" nil
         (merge
           (cmn/screen-params app-atom)
           {:task-uuid (str (:ent/uuid row))}))
       {:size :tiny}))])

(defn status [app-atom row col v]
  [:span
   {:class (u/bem :text-pill [:medium :light])
    :style
    {:background-color (or (:ent/color v) "#eeeeee")}}
   (:ent/display-name v)])

(defn status-toggle [app-atom list-atom {:keys [item-selector]} v]
  [:div
   {:style {:padding "8px 4px"}
    :class (u/bem :flex-grid-group [:flush :align-left :valign-middle])}
   [:div
    {:class (u/bem :flex-grid-block [:fluid :flush])}
    [:div.flex-grid-content
     (forms/toggle "" (rum/cursor-in list-atom [(get v item-selector) :selected?])
       {:on-change identity})]]
   [:div
    {:class (u/bem :flex-grid-block [:fluid :flush])}
    [:div.flex-grid-content
     (status app-atom {} {} v)]]])

(defn status-selected [app-atom action-config row v]
  [:span
   {:class (u/bem :text-pill [:medium :light])
    :style
    {:margin-right "4px"
     :background-color (or (:ent/color v) "#eeeeee")}}
   [:span
    (:ent/display-name v)]])

(defn generate-new-task [app-atom config]
  (let [process-atom (cmn/process-cursor app-atom)
        current (cmn/curact process-atom [:lookup :current])
        selected-team (cmn/curact process-atom [:selected-team])
        scrn-params (cmn/screen-params app-atom)]

    (u/maybe assoc
      {:ent/uuid (u/uuid)
       :task/new? true
       :airtable/date-created (dt/now)
       :task/requestor {:ent/uuid (:ent/uuid (:user current))}
       :task/team {:ent/uuid (or (:ent/uuid selected-team) (:ent/uuid (:user-team current)))}
       :task/dev-status (or {:db/ident (:db/ident config)} {:db/ident :task.dev-status/backlog})
       :task/team-status {:db/ident :task.team-status/backlog}
       :task/type {:db/ident :task.type/none}
       :task/stream {:db/ident :task.stream/none}}
      :task/urls (:urls scrn-params))))

(defn update-ref
  "Strip to only :ent/uuid, or set k to nil if not ent/uuid"
  [ent k]
  (cond
    (get-in ent [k :ent/uuid])
    (update ent k select-keys [:ent/uuid])

    :else
    (assoc ent k nil)))

(defn update-enum
  "Update to only the keyword itself"
  [ent k]
  (assoc ent k (get-in ent [k :db/ident])))

(defn reshape-task-save [task]
  (let [refs-updated
        (reduce update-ref task
          [:task/parent :task/requestor :task/project :task/team])]
    (reduce update-enum refs-updated
      [:task/dev-status :task/team-status :task/stack :task/type :task/stream :task/product])))

(defn derived-lookup-task-atom [task-atom lookup-atom]
  (rum/derived-atom [task-atom lookup-atom] :task-modal
    (fn [{:task/keys
          [team-status dev-status requestor assigned team
           budget time-spent stack product project] :as t} lookup]
      {:ent/display-name (:ent/display-name t)
       :ent/uuid (:ent/uuid t)
       :task/team-status (get-in lookup [:task.team-status (:db/ident team-status)])
       :task/dev-status (get-in lookup [:task.dev-status (:db/ident dev-status)])
       :task/type (get-in lookup [:task.type (:db/ident (:task/type t))])
       :task/stream (get-in lookup [:task.stream (:db/ident (:task/stream t))])
       :task/stack (get-in lookup [:task.stack (:db/ident stack)])
       :task/product (get-in lookup [:task.product (:db/ident product)])
       :task/requestor (get-in lookup [:requested-users (:ent/uuid requestor)])
       :task/assigned (get-in lookup [:assigned-users (:ent/uuid assigned)])
       :task/team (get-in lookup [:task.team (:ent/uuid team)])
       :task/budget (get-in lookup [:budget budget])
       :task/time-spent (get-in lookup [:time-spent time-spent])
       :task/project (get-in lookup [:task.project (:ent/uuid project)])})))

(defn filter-by-dev-status [dev-status rows]
  (let [col
        (->>
          (vals dev-status)
          (filter :selected?)
          (map :db/ident)
          (set))]
    (filter
      #(cond
         (not (empty? col))
         (contains? col (get-in % [:task/dev-status :db/ident]))

         :else
         (empty? col))
      rows)))

(defn filter-by-task-types [task-types rows]
  (let [col
        (->>
          (vals task-types)
          (filter :selected?)
          (map :db/ident)
          (set))]
    (filter
      #(cond
         (not (empty? col))
         (contains? col (get-in % [:task/type :db/ident]))

         :else
         (empty? col))
      rows)))

(defn filter-by-task-streams [task-streams rows]
  (let [col
        (->>
          (vals task-streams)
          (filter :selected?)
          (map :db/ident)
          (set))]
    (filter
      #(cond
         (not (empty? col))
         (contains? col (get-in % [:task/stream :db/ident]))

         :else
         (empty? col))
      rows)))

(defn filter-by-projects [projects rows]
  (let [col
        (->>
          (vals projects)
          (filter :selected?)
          (map :ent/uuid)
          (set))]
    (filter
      #(cond
         (not (empty? col))
         (contains? col (get-in % [:task/project :ent/uuid]))

         :else
         (empty? col))
      rows)))

(defn filter-by-assigned [assigned rows]
  (let [col
        (->>
          (vals assigned)
          (filter :selected?)
          (map :ent/uuid)
          (set))]
    (filter
      #(cond
         (not (empty? col))
         (some col (keys (get-in % [:task/assigned])))

         :else
         (empty? col))
      rows)))

(defn filter-by-requestor [requestor rows]
  (let [col
        (->>
          (vals requestor)
          (filter :selected?)
          (map :ent/uuid)
          (set))]
    (filter
      #(cond
         (not (empty? col))
         (contains? col (get-in % [:task/requestor :ent/uuid]))

         :else
         (empty? col))
      rows)))

(defn filter-by-budget [requestor rows]
  (let [col
        (->>
          (vals requestor)
          (filter :selected?)
          (map :hours)
          (set))
        col-hack (if (contains? col 0) (conj col nil) col)]
    (filter
      #(cond
         (not (empty? col-hack))
         (contains? col-hack (get % :task/budget))

         :else
         (empty? col-hack))
      rows)))

(defn filter-by-time-spent [requestor rows]
  (let [col
        (->>
          (vals requestor)
          (filter :selected?)
          (map :hours)
          (set))
        col-hack (if (contains? col 0) (conj col nil) col)]
    (filter
      #(cond
         (not (empty? col-hack))
         (contains? col-hack (get % :task/time-spent))

         :else
         (empty? col-hack))
      rows)))

(defn filter-tasks [app-atom rows]
  (let [process-atom (cmn/process-cursor app-atom)
        lookup (cmn/curact process-atom :lookup)]
    (cond
      rows
      (->>
        rows
        (filter-by-dev-status (:task.dev-status lookup))
        (filter-by-task-types (:task.type lookup))
        (filter-by-task-streams (:task.stream lookup))
        (filter-by-projects (:task.project lookup))
        (filter-by-budget (:budget lookup))
        (filter-by-time-spent (:time-spent lookup))
        (filter-by-assigned (:assigned-users lookup))
        (filter-by-requestor (:requested-users lookup)))
      
      :else
      [])))